import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
import { jsx as n } from "react/jsx-runtime";
import { calculateRem as t } from "@vds-core/utilities";
import { ColorTokens as i } from "@vds-tokens/color";
import { useRef as e } from "react";
import o, { css as r, keyframes as a } from "styled-components";
var l = function l(n) {
    var t = Math.exp,
      i = Math.sqrt,
      e = Math.sin,
      o = Math.cos;
    return -13 * t(-13 * n) * e(i(31) * n) / i(31) - t(-13 * n) * o(i(31) * n) + 1;
  },
  u = function u(n, t, i) {
    return n + i * (t - n);
  },
  d = function d() {
    var n = [],
      t = [];
    for (var _i = 0; _i <= 40; _i++) {
      var _e = l(_i / 100),
        _o = u(0, "undefined" != typeof window && window.innerHeight, _e);
      n.push(_o), t.push("undefined" != typeof window && window.innerHeight - _o);
    }
    return {
      distVals: n,
      inVals: t
    };
  },
  p = function p(n) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return "mobile" === n ? t ? "0px" : "0px 0px 0px 12px" : t ? "48px 0px 45px 0px" : "48px 0px 45px 44px";
  };
function m(n, t) {
  return "in" === n ? a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(", "px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"])), t) : function (n) {
    return a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(", "px);\n    opacity: 0;\n  }\n"])), n);
  }(t);
}
var s = o.div.withConfig({
    displayName: "ModalDialogWrapper",
    componentId: "VDS__sc-1hmtz3g-0"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-flow: column nowrap;\n  height: 99.7%;\n  line-height: ", ";\n  min-height: ", ";\n  position: relative;\n  width: 100%;\n  outline: none;\n  border-radius: ", ";\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  @media (min-width: 767px) {\n    padding: ", ";\n  }\n\n  padding: ", ";\n\n  @media (max-width: 767px) {\n    padding: ", ";\n    border-radius: 0;\n  }\n\n  ", ";\n\n  min-height: ", ";\n\n  @media (max-width: 767px) {\n    min-height: 100%;\n  }\n"])), function (_ref) {
    var n = _ref.surface;
    return "dark" === n ? i.background.primary.dark.value : i.background.primary.light.value;
  }, t(16), t(232), function (_ref2) {
    var n = _ref2.$borderRadius;
    return n;
  }, function (_ref3) {
    var n = _ref3.$modalOpened,
      t = _ref3.viewport,
      i = _ref3.$fullScreenDialog,
      e = _ref3.$disableAnimation,
      o = _ref3.$animationDistance;
    return n && ("tablet" === t && !i || "desktop" === t) && !e && r(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      animation: 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s\n        ", ";\n    "])), m("in", null != o ? o : 0));
  }, function (_ref4) {
    var n = _ref4.$unmounted,
      t = _ref4.viewport,
      i = _ref4.$fullScreenDialog,
      e = _ref4.$disableAnimation,
      o = _ref4.$animationDistance;
    return n && ("tablet" === t && !i || "desktop" === t) && !e && r(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      animation: ", " 0.4s\n        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n    "])), m("out", null != o ? o : 0));
  }, function (_ref5) {
    var n = _ref5.$modalOpened,
      t = _ref5.viewport,
      i = _ref5.$fullScreenDialog,
      e = _ref5.$disableAnimation,
      o = _ref5.$springVal;
    return n && ("mobile" === t || "tablet" === t && i) && !e && r(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      animation: ", " 400ms linear 0s;\n    "])), function (n) {
      var t = "";
      return n.forEach(function (i, e) {
        t += "".concat(e / n.length * 100, "% {top: ").concat(i, "px }");
      }), a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), t);
    }(o));
  }, function (_ref6) {
    var n = _ref6.$unmounted,
      t = _ref6.viewport,
      i = _ref6.$fullScreenDialog,
      e = _ref6.$disableAnimation;
    return n && ("mobile" === t || "tablet" === t && i) && !e && r(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      animation: ", " 400ms linear 0s;\n    "])), function (n) {
      var t = "";
      return n.forEach(function (i, e) {
        t += "".concat(e / n.length * 100, "% {top: ").concat(i, "px }");
      }), a(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), t);
    }(d().distVals));
  }, function (_ref7) {
    var n = _ref7.viewport,
      i = _ref7.$modalWidth,
      e = _ref7.$fullScreenDialog,
      o = _ref7.modalHeight,
      a = _ref7.$maxHeight,
      l = _ref7.$maxWidth;
    return "mobile" !== n && !e && r(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n      @media (min-width: 767px) {\n        height: ", "; /* Hard coded value accounting for vds ModalDialogWrapper's margin and padding */\n        ", ";\n        max-height: ", ";\n      }\n    "])), o ? "".concat(o + 96, "px") : "auto", i ? "\n              width: ".concat(i, "; // Don't apply calculateRem because user might pass %, vw, px, or number\n              max-width: ").concat(l, ";\n            ") : "width: ".concat(t(560), ";"), a);
  }, function (_ref8) {
    var n = _ref8.$fullWidthContent;
    return p("desktop", n);
  }, function (_ref9) {
    var n = _ref9.viewport,
      t = _ref9.$fullWidthContent;
    return p(n, t);
  }, function (_ref0) {
    var n = _ref0.$fullWidthContent;
    return p("mobile", n);
  }, function (_ref1) {
    var n = _ref1.$fullScreenDialog,
      t = _ref1.viewport,
      i = _ref1.$mobileHeight;
    return (n || "mobile" === t) && "\n    height: ".concat(i, " !important;\n    width: 100vw !important;\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  ");
  }, function (_ref10) {
    var n = _ref10.viewport;
    return "mobile" === n && "100%";
  }),
  c = function c(t) {
    var i = e(d().inVals);
    return n(s, Object.assign({}, t, {
      $springVal: i.current
    }));
  };
c.defaultProps = {
  viewport: "desktop",
  $fullScreenDialog: !1,
  $animationDistance: 150
};
export { c as default };